export default [
    {to: "/app/dashboard", text: "首页", icon: "wq-dashboard"},
    {to: "/app/rcs/message/task", text: "RCS发送", icon: "wq-telegram"},
    {to: "/app/ws/message/task", text: "WS发送", icon: "wq-whatsapp"},
    {to: "/app/sms/message/task", text: "SMS发送", icon: "wq-momo"},
    {to: "/app/detection", text: "筛选", icon: "wq-sieve", children : [
        {to: "/app/detection/2280", text:  "空号筛选"},
        {to: "/app/detection/2001", text: "手机号活跃筛选"},
        {to: "/app/detection/2140", text: "Whatsapp筛选"},
        {to: "/app/detection/2110", text: "Telegram筛选"},
        {to: "/app/detection/2340", text: "Rcs筛选"},
        {to: "/app/detection/2610", text: "Imessage筛选"},
        {to: "/app/detection/2649", text: "北美运营商筛选"},
    ]},
    {to: "/app/finance", text: "费用管理", icon: "wq-finance", children : [
            {to: "/app/finance/recharge/add", text:  "充值记录"},
            {to: "/app/finance/recharge/deduct", text: "扣值记录"},
            {to: "/app/finance/consume/customer", text: "消耗记录"}
        ]},
    {to: "/app/notice", text: "平台公告", icon: "wq-notice", domestic: true},
]
